import { postApi } from '../api/payment';
const createCheckout = async ({ lineItems, uiMode, successUrl, token }, logger) => {
    const urlParams = new URLSearchParams();
    urlParams.append('uimode', uiMode);
    if (uiMode === 'hosted')
        urlParams.append('successUrl', successUrl);
    const response = await postApi({ lineItems }, token, `/session/create?${urlParams.toString()}`, logger);
    return response;
};
export default createCheckout;
